import {
  myMessageView,
  contractView,
  receiverAddressView,
  messageView,
  salesmanView,
  customMessageView,
  userView,
  couponView,
} from "~/views/UserCenter/index";
import Layout from "~/layout/index.vue";
const footerName = "user-center";
const UserCenterRoutes = {
  path: "/user",
  component: Layout,
  children: [
    {
      path: "",
      name: footerName,
      component: userView,
      meta: {
        title: "用户中心",
        isBack: false,
        isHeaderShow: false,
        footerName,
      },
    },
    {
      path: "myMessage",
      name: "myMessage",
      component: myMessageView,
      meta: {
        title: "我的信息",
        isBack: true,
        isHeaderShow: true,
        footerName,
      },
    },
    {
      path: "contract",
      name: "contract",
      component: contractView,
      meta: {
        title: "服务协议",
        isBack: true,
        isHeaderShow: true,
        footerName,
      },
    },
    {
      path: "receiverAddress",
      name: "receiverAddress",
      component: receiverAddressView,
      meta: {
        title: "收货地址",
        isBack: true,
        isHeaderShow: true,
        footerName,
      },
    },
    {
      path: "message",
      name: "message",
      component: messageView,
      meta: {
        title: "消息列表",
        isBack: true,
        isHeaderShow: true,
        footerName,
      },
    },
    {
      path: "salesman",
      name: "salesman",
      component: salesmanView,
      meta: {
        title: "业务员",
        isBack: true,
        isHeaderShow: true,
        footerName,
      },
    },
    {
      path: "customMessage",
      name: "customMessage",
      component: customMessageView,
      meta: {
        title: "消息定制",
        isBack: true,
        isHeaderShow: true,
        footerName,
      },
    },
    {
      path: "coupon",
      name: "coupon",
      component: couponView,
      meta: {
        title: "优惠券",
        isBack: true,
        isHeaderShow: true,
        footerName,
      },
    },
  ],
};

export { UserCenterRoutes };
